import { BaseUrl, ENV as LibENV } from '@smartera/core';

export class Urls {
	public static readonly LocalEnv: BaseUrl = new BaseUrl({
		url: 'http://localhost:8080',
		subDirectory: 'total',
	});

	public static readonly DevEnv: BaseUrl = new BaseUrl({
		url: 'https://findev.smartycubes.com',
		subDirectory: 'total',
	});

	public static readonly AzureEnv: BaseUrl = new BaseUrl({
		url: 'https://app.smartycubes.com',
		subDirectory: 'total',
	});

	public static readonly KFKTest: BaseUrl = new BaseUrl({
		url: 'https://smartyfin.now.tofas.com.tr',
		subDirectory: 'total',
	});

	public static readonly KFKProd: BaseUrl = new BaseUrl({
		url: 'https://kfk.now.tofas.com.tr',
		subDirectory: 'total',
	});

	public static readonly Dynamic: BaseUrl = new BaseUrl({
		url: globalThis.window.location.protocol + '//' + globalThis.window.location.hostname,
		port: location.port,
		subDirectory: 'total',
	});

	public static BASE_URL: BaseUrl = Urls.LocalEnv;
}

export interface ENV extends LibENV {
	smartyGpt: boolean;
	demo?: boolean;
}
